import cn from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

import useIsMobile from '@/src/hooks/useIsMobile';

import {PreviewImageVideo, Text} from '../../../ui';
import css from '../../styles/Video.module.css';

const Video = ({
  title,
  image,
  duration,
  onTopicVideoClick,
  isActive,
  contentCreator,
}) => {
  const {isMaxWidth600} = useIsMobile();
  return (
    <div
      onClick={onTopicVideoClick}
      className={cn(css.main, {
        [css.active]: isActive,
      })}
    >
      <div className={css.preview}>
        <PreviewImageVideo image={image} />
      </div>
      <div className={css.contentCretor}>
        <Text
          isOneLine
          color={Text.COLOR.GREY}
          fontSize={
            isMaxWidth600 ? Text.FONT_SIZE.SIZE_12 : Text.FONT_SIZE.SIZE_14
          }
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
          lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1_6}
        >
          {contentCreator.name}
        </Text>
      </div>
      <div className={css.duration}>
        <Text
          fontSize={
            isMaxWidth600 ? Text.FONT_SIZE.SIZE_12 : Text.FONT_SIZE.SIZE_14
          }
          color={Text.COLOR.GREY}
          lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1_6}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          {duration}
        </Text>
      </div>
      <div className={css.videoTile}>
        <Text
          color={Text.COLOR.PRIMARY}
          fontWeight={Text.FONT_WEIGHT.BOLD}
          fontSize={
            isMaxWidth600 ? Text.FONT_SIZE.SIZE_12 : Text.FONT_SIZE.SIZE_16
          }
          lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_24}
        >
          {title}
        </Text>
      </div>
    </div>
  );
};

Video.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  duration: PropTypes.string.isRequired,
  onTopicVideoClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  contentCreator: PropTypes.object.isRequired,
};

export default Video;
